<template>
    <Layout>
      <PageHeader :title="title" :items="items"></PageHeader>
      <WaitingForDocsTable></WaitingForDocsTable>
    </Layout>
  </template>
  
  <script>
  import Layout from '../../../../layouts/main.vue';
  import PageHeader from '../../../../../components/page-header.vue';
  import WaitingForDocsTable from '../../components/maintenance/workOrders/reports/waitingForDocsTable.vue';
  
  export default {
    components: { Layout, PageHeader, WaitingForDocsTable },
    data() {
      return {
        title: 'Waiting for Documents Report',
        items: [
          {
            text: 'home',
            href: '/',
          },
          {
            text: 'waiting for documents',
            href: '/production/maintenance/reports/waitingForDocuments',
            active: true,
          },
        ],
      };
    },
  };
  </script>
  